const SUGGESTIONS = [
  {
    label: 'Why was Order A scheduled instead of Order B?',
    suggestion: 'Why was Order A scheduled instead of Order B?',
  },
  {
    label: 'Why did Tech 1 get Order C put on his/her route?',
    suggestion: 'Why did Tech 1 get Order C put on his/her route?',
  },
  {
    label: `How many Orders are on Tech 1's route for the day?`,
    suggestion: `How many Orders are on Tech 1's route for the day?`,
  },
  {
    label: 'How many Orders were Executed vs. Planned?',
    suggestion: 'How many Orders were Executed vs. Planned?',
  },
  {
    label: 'Are any Orders running late?',
    suggestion: 'Are any Orders running late?',
  },
  {
    label: 'Which Orders did NOT make the optimization and were left out?',
    suggestion: 'Which Orders did NOT make the optimization and were left out?',
  },
]

export function useSuggestions() {
  // Placeholder for future implementation
  return SUGGESTIONS
}
